import { Button, buttonClasses, styled } from "@mui/material";
import clsx from "clsx";
import { useRef, useState } from "react";

import CheckMarkIcon from "@/assets/icons/check-mark.svg?react";
import CopyIcon from "@/assets/icons/copy.svg?react";
import { copyLinkToClipboard } from "@/shared/lib";

import styles from "./styles.module.css";

const StyledButton = styled(Button)(() => ({
  fontSize: "16px",
  fontWeight: "400",
  letterSpacing: "0.1px",
  textTransform: "none",
  [`& .${buttonClasses.startIcon}`]: {
    marginRight: "4px",
  },
}));

type OwnProps = React.ClassAttributes<HTMLPreElement> &
  React.HTMLAttributes<HTMLPreElement>;

interface IProps extends OwnProps {}

const Pre = ({ className, ...restProps }: IProps) => {
  const preRef = useRef<HTMLPreElement>(null);

  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    if (!preRef.current) {
      return;
    }
    const content = preRef.current.innerText;
    await copyLinkToClipboard(content);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  return (
    <div className={styles["pre-wrapper"]}>
      <div className={styles["pre-header"]}>
        {isCopied ? (
          <p>
            <CheckMarkIcon width={20} height={20} color="#4E77FB" />
            <span>Скопировано</span>
          </p>
        ) : (
          <StyledButton
            variant="text"
            startIcon={<CopyIcon width={20} height={20} color="#4E77FB" />}
            onClick={handleCopy}
          >
            Скопировать
          </StyledButton>
        )}
      </div>
      <pre
        className={clsx(className, styles.pre)}
        ref={preRef}
        {...restProps}
      />
    </div>
  );
};

export default Pre;
